import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useClientPortalDispatch, setCancelModalOpen } from "../../../../redux/";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";

import styles from "./AppointmentBookingHeader.module.css";
import { useBookingNavigation } from "../../hooks/useBookingNavigation";

export default function AppointmentBookingHeader() {
    const theme = useTheme();
    const dispatch = useClientPortalDispatch();
    const { handleNext, handlePrevious } = useBookingNavigation();

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleCancel = () => {
        dispatch(setCancelModalOpen(true));
    };

    return (
        <Box className={styles.wrapper} data-test-id="appointment_booking_header_wrapper">
            {isMobile ? (
                <HeaderMobile handlePrevious={handlePrevious} handleNext={handleNext} handleCancel={handleCancel} />
            ) : (
                <HeaderDesktop handlePrevious={handlePrevious} handleNext={handleNext} handleCancel={handleCancel} />
            )}
        </Box>
    );
}
